// @TODO - translate for locale

export const secondaryNavData = {
  title: 'Scroll down for',
  tabs: [
    {
      title: 'latest content',
      url: '#latest-content',
      active: true,
    },
    {
      title: 'circular economy examples',
      url: '#circular-economy-examples',
      active: false,
    },
    {
      title: 'who we are',
      url: '#who-we-are',
      active: false,
    },
  ],
};
